import React from 'react';
import useBundleTranslation from 'i18n';
import { Input, Box } from '@mui/material';
import { FormControlCompareInputFieldProps, FormElementControlPropsType } from './index';
import styles from './FormCompareField.style';
import { FormComponentBuilder } from 'components/common/form/layout';

export default function FormCompareInput({
    controlProps,
    elementProps,
}: FormElementControlPropsType<FormControlCompareInputFieldProps>) {
    const { t } = useBundleTranslation(elementProps?.translationNS ?? 'components/common/form/form');
    const period = controlProps.form.hookFormWatch(controlProps.periodFieldName);
    const unit = controlProps.form.hookFormWatch(controlProps.unitFieldName);

    const handlePeriodChange = (event: any) => {
        const value = event.target.value;

        if (!/[a-zA-Z]/.test(value)) {
            controlProps.form.hookFormSetValue(controlProps.periodFieldName, value, { shouldDirty: true });
        }
    };

    const handleUnitChange = (event: any) => {
        controlProps.form.hookFormSetValue(controlProps.unitFieldName, event.target.value, { shouldDirty: true });
    };

    return (
        <Box sx={styles.root}>
            <Box sx={styles.fields}>
                <Input
                    value={period}
                    sx={{ maxWidth: 80 }}
                    onChange={handlePeriodChange}
                    name={controlProps.periodFieldName}
                    data-test={controlProps.uid + '_' + controlProps.periodFieldName}
                    inputProps={{ 'data-1p-ignore': true }}
                />
                <Input
                    value={unit}
                    sx={{ maxWidth: 80, ml: 1 }}
                    onChange={handleUnitChange}
                    name={controlProps.unitFieldName}
                    data-test={controlProps.uid + '_' + controlProps.unitFieldName}
                    inputProps={{ 'data-1p-ignore': true }}
                />
                {controlProps.extraText && <Box sx={styles.extraText}>{t(controlProps.extraText as string)}</Box>}
            </Box>
        </Box>
    );
}

export class FormCompareInputBuilder extends FormComponentBuilder {
    prepareProps(): FormControlCompareInputFieldProps {
        return {
            ...this.controlProps,
            extraText: this.elementProps.componentProps?.extraText ?? '',
            unitFieldName: this.elementProps.componentProps?.unitFieldName ?? '',
            periodFieldName: this.elementProps.componentProps?.periodFieldName ?? '',
        };
    }
}
